// extracted by mini-css-extract-plugin
module.exports = {"root":"D_bJ"};